import { render, staticRenderFns } from "./ProxyHolder.vue?vue&type=template&id=ec84634e&scoped=true"
import script from "./ProxyHolder.vue?vue&type=script&lang=js"
export * from "./ProxyHolder.vue?vue&type=script&lang=js"
import style0 from "./ProxyHolder.vue?vue&type=style&index=0&id=ec84634e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec84634e",
  null
  
)

export default component.exports